import { render, staticRenderFns } from "./EditBus.vue?vue&type=template&id=72f8b90a&"
import script from "./EditBus.vue?vue&type=script&lang=js&"
export * from "./EditBus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports